<script setup>
import { ref, onMounted, reactive, computed, watch, nextTick, } from 'vue'
import { gApp } from '../State.js'
import QuickHelpNode from './QuickHelpNode.vue'
import { QuickHelpParser } from '../Common/QuickHelpParser.js'

const props = defineProps({
  id: {
    required: true,
  }
});

let parsedSections = ref(null);
let isLoading = ref(true);
let parser = null;

async function loadContent() {
  try {
    // Create parser once and reuse it
    if (!parser) {
      parser = new QuickHelpParser();
    }
    const rootNode = await parser.parseFile(props.id);
    parsedSections.value = rootNode;
  } catch (error) {
    console.error('Error loading help content:', error);
    parsedSections.value = null;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  loadContent();
});

// Watch for prop changes
watch(() => props.id, () => {
  isLoading.value = true;
  loadContent();
});

</script>

<template>
  <div class="Paragraphs">
    <div v-if="parsedSections">
      <QuickHelpNode 
        v-for="(section, index) in parsedSections" 
        :key="index"
        :node="section"
        :level="0"
      />
    </div>
    <div v-else-if="parsedSections === null && !isLoading">
      <p>There is no help info for this page. If you need assistance, click 'Get Help' in the top-right.</p>
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>

<style scoped>
/* Styles are now handled in QuickHelpNode.vue */
</style>
